import axiosInstance from '@/core/api'
import axiosDefuault from 'axios'
import {
	GetOperatorMeResponse,
	GetUploadFileUrlResponse,
	GetUploadlFileUrlRequest,
} from '@/modules/operator/type'

export const getOperatorMe = async (): Promise<GetOperatorMeResponse> => {
	const response = await axiosInstance.get<GetOperatorMeResponse>(
		'/admin/operators/me',
	)
	return response.data
}

export const getUploadCarouselFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-carousel-upload-file-url`,
		request,
	)
	return response.data
}

export const getPromotionUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-promotion-upload-file-url`,
		request,
	)
	return response.data
}

export const getRankBannerUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-rank-banner-upload-file-url`,
		request,
	)
	return response.data
}

export const getRankFrameUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-rank-frame-upload-file-url`,
		request,
	)
	return response.data
}

export const getCommissionBannerUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-commission-cashback-upload-file-url`,
		request,
	)
	return response.data
}

export const getReturnBannerUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-return-loss-upload-file-url`,
		request,
	)
	return response.data
}

export const getBannerGameUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-game-page-banner-upload-file-url`,
		request,
	)
	return response.data
}

export const getLoginAnnounceUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-login-announce-upload-file-url`,
		request,
	)
	return response.data
}

export const getLuckyWheelImageUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-lucky-wheel-image-upload-file-url`,
		request,
	)
	return response.data
}

export const getArrowLuckyWheelImageUploadFileUrl = async (
	request: GetUploadlFileUrlRequest,
): Promise<GetUploadFileUrlResponse> => {
	const response = await axiosInstance.post<GetUploadFileUrlResponse>(
		`/admin/file/get-lucky-wheel-arrow-image-upload-file-url`,
		request,
	)
	return response.data
}

export const uploadFileToPresignedUrl = async (url: string, file: File) => {
	try {
		const response = await axiosDefuault.put(url, file, {
			headers: { 'Content-Type': file.type },
		})
		return response.data
	} catch (error: any) {
		console.log(error)
		throw error
	}
}
